<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <section class="hero-section ptb-100" style="background:#00A39C">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-9 col-lg-7">
                        <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                            <h1 class="text-white mb-0">Alquiler de Canchas</h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="module ptb-100">
            <div class="container">
                <div class="row mb-5">
                    <div class="col-md-8 offset-md-2">

                        <div class="row">
                            <div class="col-xs-12 col-md-5">
                                <span class="mr-4"><strong>Seleccione un club zonal o parque:</strong></span>
                            </div>
                            <div class="col-xs-12 col-md-7">
                                <el-select v-model="selectSede" filterable placeholder="Seleccione una sede"
                                    @change="getMoreInfo" size="large"
                                    loading-text="Cargando...espere un momento por favor">
                                    <el-option v-for="item in listSedes" :key="item.codigoArea"
                                        :label="item.areaDescripcion" :value="item.codigoArea"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <!--<div class="d-flex align-items-center">

                    </div>-->
                    </div>
                </div>

                <el-divider></el-divider>

                <div class="row">
                    <div class="col-lg-8 col-md-8">
                        <article class="post pb-0 mb-3 border-0">
                            <div class="post-preview d-none">
                                <img src="https://appco.themetags.com/img/blog/1-w.jpg" alt="article" class="img-fluid">
                            </div>
                            <div class="post-wrapper">
                                <div class="post-header mt-0">
                                    <h2>{{ seat.areaDescripcion }}</h2>
                                </div>
                            </div>
                        </article>
                        <div class="reserva mb-5">
                            <!--<h5 class="text-dark">Reservas</h5>-->
                            <el-divider content-position="left">Reservas</el-divider>
                            <div class="row">
                                <div class="col-sm-5">
                                    <label for="dateInput" class="mb-1 font-size-h5">Tipo de cancha</label>
                                    <el-select v-model="selectCancha" placeholder="Seleccione tipo de cancha"
                                        @change="getListDeporte">
                                        <el-option v-for="item in listTipos" :key="item.value" :label="item.text"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="col-sm-4" v-if="selectCancha != null && listDeportes.length != 0">
                                    <div><label for="hourInput" class="mb-1 font-size-h5">Deporte que realizará</label>
                                        <el-select v-model="selectDeporte" placeholder="Seleccione deporte"
                                            @change="getListLosas">
                                            <el-option v-for="item in listDeportes" :key="item.value" :label="item.text"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="col-sm-3"
                                    v-if="selectDeporte != null && selectCancha != null && listLosas.length != 0">
                                    <div><label for="hourInput" class="mb-1 font-size-h5">Losas disponibles</label>
                                        <el-select v-model="selectLosa" placeholder="Seleccione losa"
                                            @change="getNewHourClosed">
                                            <el-option v-for="item in listLosas" :key="item.value" :label="item.text"
                                                :value="item.value" :disabled="mdisabled[item.detalle].value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="row">
                                <div class="col-sm-12" v-if="blockCalendar">
                                    <FullCalendar ref="fullCalendar" class="demo-app-calendar"
                                        :plugins="calendarPlugins" defaultView="timeGridWeek" :events="calendarEvents"
                                        :header="calendarHeader" :slotLabelFormat="slotLabelFormat"
                                        :minTime="inicioCalendar" :maxTime="finCalendar" :weekends="calendarWeekends"
                                        :allDaySlot="false" slotDuration="01:00:00" locale="es" height="auto"
                                        @dateClick="handleDateClick" :datesRender="onDatesRender" />

                                </div>
                                <!----:datesRender="onDatesRender"-->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class="sidebar-right pl-4">
                            <div class="widget mb-3" v-if="selectSede != null && selectSede != ''">
                                <div class="widget-title mb-1">
                                    <h5 class="text-dark mb-0">Información</h5>
                                </div>
                                <ul>
                                    <li><span>Teléfono: {{ seat.telefono }}</span></li>
                                    <li><span>Dirección : {{ seat.direccion }}</span></li>
                                    <li><span><b>Distrito:</b> {{ seat.distrito }}</span></li>
                                    <li><a class="my-3 btn btn-info text-white"
                                            :href="'https://maps.google.com/?ll=' + seat.latitud + ',' + seat.longitud + '&z=18&t=k'"
                                            target="_blank">Ver en el mapa</a></li>
                                </ul>
                            </div>
                            <!--<el-divider content-position="left">Precios x hora</el-divider>-->
                            <!--<el-alert v-if="blockCalendar"
                            title="Informacion de la cancha"
                            type="info"
                            description="Solo 4 personas por cancha"
                            show-icon>
                        </el-alert>-->
                            <el-collapse v-model="activeNames">
                                <el-collapse-item title="CONDICIONES DE RESERVA" name="1">
                                    <div class="alert alert-info mb-3" role="alert">
                                        <p class="mb-0"><b>Cancelaciones y reembolso:</b> No se otorgan reembolsos por
                                            cancelaciones de reservas de canchas y/o losas.</p>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Reprogramación:</b> Las solicitudes de reprogramación deben
                                            enviarse con 24 horas de anticipación como mínimo, al correo
                                            atencionalusuario@serpar.gob.pe.</p>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Antelación de reserva:</b> Las reservan pueden realizarse
                                            máximo con un mes de anticipación.</p>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Número máximo de jugadores:</b> Los usuarios deben respetar
                                            el aforo permitido según la cancha y/o losa reservada: </p>
                                        <ul>
                                            <li>Fútbol 5: 10 personas</li>
                                            <li>Fútbol 6: 12 personas</li>
                                            <li>Fútbol 7: 14 personas</li>
                                            <li>Fútbol 11: 22 personas</li>
                                            <li>Vóley 6: 12 personas</li>
                                        </ul>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Jugadores y Acompañantes:</b> Los jugadores y sus
                                            acompañantes deben realizar el pago de entrada al parque. Sin embargo, una
                                            vez que el parque se encuentre cerrado, no se permitirá el ingreso de
                                            acompañantes bajo ninguna circunstancia.</p>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Estacionamiento:</b> La reserva de cancha no incluye
                                            estacionamiento. Los usuarios y acompañantes deben pagar el estacionamiento
                                            previamente.</p>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Conducta:</b> : Se encuentra prohibido el ingreso y/o consumo
                                            de bebidas alcohólicas y/o sustancias estupefacientes, así como cualquier
                                            conducta que ponga en peligro la integridad o vaya en contra de las buenas
                                            costumbres. El incumplimiento de estas normas faculta al parque a cancelar
                                            la reserva y solicitar el retiro de los usuarios y/o acompañantes.</p>
                                        <hr class="m-1">
                                        <p class="mb-0"><b>Uso adecuado:</b> : Las canchas y/o losas deportivas solo
                                            deben ser usadas para el deporte reservado. El uso con fines distintos
                                            faculta al parque a requerir el pago correspondiente.</p>
                                        <hr class="m-1">
                                    </div>
                                </el-collapse-item>
                                <!--<el-collapse-item title="RECUERDA" name="2">
                            <div class="alert alert-info mb-3" role="alert">
                              <p class="mb-0">Podrás realizar tu reserva con un máximo de 1 mes de anticipación.</p>
                              <hr class="m-1">
                              <p class="mb-0">Una vez pagada la reserva no hay lugar a reprogramación.</p>
                              <hr class="m-1">
                              <p class="mb-0">En caso de no usar el campo no se devolverá el dinero.</p>
                              <hr class="m-1">
                              <p class="mb-0">Solo ingresan las personas que participen en los encuentros:
                                <ul>
                                  <li>Futbol 5 -> 10 personas.</li>
                                  <li>Futbol 6 -> 12 personas</li>
                                  <li>Futbol 7 -> 14 personas</li>
                                  <li>Futbol 11 -> 22 personas</li>
                                  <li>Voley 6 -> 12 personas</li>
                                </ul>
                              </p>
                              <hr class="m-1">
                              <p class="mb-0">Los invitados y/o espectadores pagan su ingreso al Parque.</p>
                              <hr class="m-1">
                              <p class="mb-0">Acompañantes y jugadores que asistan con vehículos pagan estacionamiento.</p>
                            </div>
                          </el-collapse-item>-->
                                <el-collapse-item title="RESTRICCIONES" name="2">
                                    <div class="alert alert-info mb-3" role="alert">
                                        <p class="mb-0">Estas reservas no aplican para academias, escuelas o clubes
                                            deportivos, en caso lo hicieran no se le permitirá el acceso al parque ni se
                                            le devolverá el dinero de la reserva.</p>
                                    </div>

                                </el-collapse-item>

                            </el-collapse>

                            <template>
                                <el-table :data="listarPrecioLosa" border style="width: 100%" class="prices">
                                    <el-table-column label="Dia/Hora" label-class-name="bg-table-price">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.dias }} de {{ scope.row.inicio }}:00 a
                                                {{ scope.row.fin }}:00</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="price" label="Precio x hora" width="120px"
                                        label-class-name="bg-table-price">
                                        <template slot-scope="scope">
                                            <span>S/ {{ scope.row.precioUnitario }}.00</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                            <div class="sky-form">
                                <div class="my-5 form-group otherRow row landscape-row brand-view">
                                    <div class="col col-4 text-left"><img
                                            src="https://static-content.vnforapps.com/v2/img/pci.png"
                                            class="icon_logos2"> </div>
                                    <div class="col col-8 text-right">
                                        <img src="https://static-content.vnforapps.com/v2/img/bottom/visa.png"
                                            class="band_logos">
                                        <img src="https://static-content.vnforapps.com/v2/img/bottom/mc.png"
                                            class="band_logos multibrand icon-mastercard" style="display: inline;">
                                        <img src="https://static-content.vnforapps.com/v2/img/bottom/dc.png"
                                            class="band_logos multibrand icon-dinersclub" style="display: inline;">
                                        <img src="https://static-content.vnforapps.com/v2/img/bottom/amex.png"
                                            class="band_logos amex_logo multibrand icon-amex" style="display: inline;">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="Reservar y pagar" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="60%"
            top="3vh" @close="closePopup" @opened="onOpenedModal">
            <div class="alert alert-primary" role="alert" v-if="listPreciosEntradas.length > 0">
                Estimados clientes, les recordamos que para adquirir el servicio de alquiler de losas deportivas es
                necesario
                comprar las entradas correspondientes. Para utilizar el servicio de estacionamiento, deberá comprar su
                ticket de
                acuerdo al número de vehículos con el que desea ingresar.
            </div>

            <el-form :model="form" status-icon :rules="rules" ref="form" label-position="left">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="grid-content">
                            <h6 class="font-size-lg text-info font-weight-bold mb-6">1. Datos de reserva</h6>
                            <el-form-item label="Fecha seleccionada" label-width="150px">
                                <el-input v-model="form.startDate" readonly></el-input>
                            </el-form-item>
                            <el-row :gutter="20">
                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                    <el-form-item label="Hora de inicio">
                                        <el-input v-model="form.startHour" readonly></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                    <el-form-item label="Horas a reservar" prop="cantHour">
                                        <el-select v-model="form.cantHour" placeholder="Seleccione una hora"
                                            @change="calculateEndHourPrice">
                                            <el-option v-for="item in listHours" :key="item.hour" :label="item.text"
                                                :value="item.hour"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                    <el-form-item label="Hora de termino">
                                        <el-input v-model="form.endHour" readonly></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                    <el-form-item :label="'Importe'" class="mb-0"><br>
                                        <h4 class="text-primary" v-text="'S/ ' + form.total.toFixed(2)"></h4>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <!--<el-row :gutter="20" class="mb-4">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-checkbox v-model="entradasCanchas">Deseo comprar mis entradas</el-checkbox>
                            </el-col>
                        </el-row>-->

                            <div v-if="listPreciosEntradas.length > 0" class="mb-4">
                                <h6 class="font-size-lg text-info font-weight-bold mb-6">Compra de entradas</h6>
                                <div class="row align-items-center border-bottom py-2"
                                    v-for="(item, index) in listPreciosEntradas" :key="index">
                                    <div class="col-sm-6">
                                        {{ item.descripcion }} | <span class="badge bg-info rounded text-white">S/
                                            {{ item.precioUnitario.toFixed(2) }}</span>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-input-number v-model="entradas.parent_id[index]" :key="item.codigo"
                                            @change="handleChange" :min="0" :max="10" size="small"></el-input-number>
                                    </div>
                                </div>
                            </div>

                            <!--<el-divider content-position="left">Precios x hora</el-divider>-->

                            <el-table :data="listarPrecioLosa" border style="width: 100%" :class="'prices mb-4'">
                                <el-table-column label="Dia/Hora" label-class-name="bg-table-price">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.dias }} de {{ scope.row.inicio }}:00 a
                                            {{ scope.row.fin }}:00</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="price" label="Precio x hora" label-class-name="bg-table-price">
                                    <template slot-scope="scope">
                                        <span>S/ {{ scope.row.precioUnitario }}.00</span>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div v-if="listPrecioEsta.length == 1" class="">

                                <el-alert title="Agregar servicio de estacionamiento" type="success" effect="dark"
                                    :closable="false">
                                </el-alert>

                                <div class="row mt-4 text-center">
                                    <div class="col-sm-6">
                                        <span><b>Número de vehiculos</b></span>
                                        <el-input-number v-model="estacionamiento.carros" :min="0" :max="15"
                                            @change="handleChangeEst"></el-input-number>
                                    </div>
                                    <div class="col-sm-6">
                                        <span><b>Importe</b></span>
                                        <h4 class="text-primary border rounded p-2">S/
                                            {{ estacionamiento.importe.toFixed(2) }}
                                        </h4>
                                    </div>
                                </div>

                                <hr>

                            </div>
                            <div class="row">

                                <div class="col-sm-6 text-right pt-2"><b>Importe a total a pagar</b></div>

                                <div class="col-sm-6">

                                    <h4 class="text-white bg-primary border rounded p-2 text-center">S/
                                        {{ total_pagar.toFixed(2) }}</h4>

                                </div>

                            </div>

                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <div class="grid-content">
                            <h6 class="font-size-lg text-info font-weight-bold mb-2">2. Datos de contacto</h6>

                            <el-form-item label="Documento" label-width="100px" class="mb-4" prop="cndoc">
                                <el-input placeholder="Nro documento" v-model="form.cndoc" class="input-with-select"
                                    size="medium" :clearable="true" :maxlength="maxlength">
                                    <el-select v-model="form.cdoc" slot="prepend" placeholder="Seleccione"
                                        @change="changeTipoDoc">
                                        <el-option v-for="item in listDocument" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>

                            <el-form-item label="Nombres" label-width="100px" prop="cname">
                                <el-input v-model="form.cname" placeholder="Nombres y apellidos completos"
                                    size="medium"></el-input>
                            </el-form-item>
                            <el-form-item label="Celular" label-width="100px" prop="cphone">
                                <el-input v-model.number="form.cphone" placeholder="N° de celular" size="medium"
                                    maxlength="9"></el-input>
                            </el-form-item>
                            <el-form-item label="Email" label-width="100px" prop="cemail">
                                <el-input v-model="form.cemail" placeholder="Correo electrónico"
                                    size="medium"></el-input>
                            </el-form-item>

                            <h6 class="font-size-lg text-info font-weight-bold mt-4 mb-2">3. Datos de facturación</h6>

                            <el-form-item label="Comprobante" label-width="120px" class="mb-4" prop="fndoc">
                                <el-input :placeholder="placeHolder.voucher" v-model="form.fndoc"
                                    class="input-with-select" size="medium" :clearable="true" :maxlength="maxlength">
                                    <el-select v-model="form.voucher" slot="prepend" placeholder="Seleccione"
                                        @change="changeTpodocument">
                                        <el-option key="03" label="Boleta" value="03"></el-option>
                                        <el-option key="01" label="Factura" value="01"></el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="placeHolder.namebussines" label-width="120px" prop="fname"
                                size="medium">
                                <el-input v-model="form.fname" :placeholder="placeHolder.namebussines"></el-input>
                            </el-form-item>
                            <el-form-item label="Celular" label-width="120px" prop="fphone">
                                <el-input v-model.number="form.fphone" placeholder="N° de celular" maxlength="9"
                                    size="medium"></el-input>
                            </el-form-item>
                            <el-form-item label="Email" label-width="120px" prop="femail">
                                <el-input v-model="form.femail" placeholder="Correo electrónico"
                                    size="medium"></el-input>
                            </el-form-item>
                            <hr>
                            <el-checkbox v-model="terms">
                                He leído y acepto los
                                <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf"
                                    target="_blank"><b>Términos y Condiciones</b></a></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancelar</el-button>
                <el-button type="success" @click="submitForm('form')">Ir a pagar</el-button>
            </span>

        </el-dialog>

        <!---->
        <el-dialog :visible.sync="dialogPopUp" width="600px" top="5vh" class="popup" :show-close="false">
            <div slot="title" class="dialog-header">
                <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="dialogPopUp = false">
                    <i class="el-dialog__close el-icon el-icon-close bg-warning rounded-circle p-2"></i>
                </button>
            </div>
            <a v-if="popup.link != ''" :href="popup.link" target="_blank">
                <img :src="popup.img" class="w-100" />
            </a>
            <img v-else :src="popup.img" class="w-100" />

        </el-dialog>
        <!---->

    </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

// must manually include stylesheets for each plugin
import "@fullcalendar/core/main.css";
import "@fullcalendar/timegrid/main.css";
import "@fullcalendar/daygrid/main.css";

import moment from 'moment';
import esLocale from '@fullcalendar/core/locales/es'

import data from "@/data/common";

//services
import services from "@/services/services.service"

export default {
    components: {
        FullCalendar
    },
    data() {
        var validateDoc = (rule, value, callback) => {
            if (value === '')
                callback(new Error(" Ingrese nro. documento"));
            else if (this.form.cdoc === '01' && value.length < 8)
                callback(new Error("DNI debe tener 8 dígitos"))
            else
                callback();
        };
        var validateComp = (rule, value, callback) => {
            if (value === '')
                callback(new Error(" Ingrese nro. documento"));
            else if (this.form.voucher === '03' && value.length < 8)
                callback(new Error("DNI debe tener 8 dígitos"))
            else if (this.form.voucher === '01' && value.length < 11)
                callback(new Error("RUC debe tener 11 dígitos"))
            else
                callback();
        };

        return {
            dialogPopUp: false,
            activeNames: ['1'],
            popup: {},
            calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin
            ],
            maxlength: 8,
            entradasCanchas: false,
            checkboxGroupEntradas: [],
            listPreciosEntradas: [],
            calendarWeekends: true,
            calendarEvents: [],
            blockCalendar: false,
            slug: null,
            seat: [],
            selectSede: null,
            listSedes: [],
            inicioCalendar: null,
            finCalendar: null,
            finCalendar2: null,
            listDocument: data.document,
            listBilling: data.billing,
            mdisabled: data.mdisabled,
            selectCancha: null,
            selectDeporte: null,
            selectLosa: null,
            listTipos: [],
            listDeportes: [],
            listLosas: [],
            fullscreenLoading: false,
            selectDateHour: null,
            listHours: data.hours,
            terms: false,
            dialogFormVisible: false,
            listarPrecioLosa: [],
            detailCourt: [],
            detailEntradas: [],
            getDetailSeat: {},
            placeHolder: {
                voucher: 'DNI',
                namebussines: 'Nombres'
            },
            form: {
                operation: null,
                seat: null,
                startDate: null,
                startHour: null,
                endHour: null,
                cantHour: 1,
                total: 0.00,
                totalEntradas: 0.00,
                voucher: '03',
                cdoc: '01',
                cndoc: '',
                cname: '',
                cphone: '',
                cemail: '',
                fndoc: '',
                fname: '',
                fphone: '',
                femail: '',
            },
            entradas: {
                parent_id: []
            },
            estacionamiento: {
                carros: 0,
                precio: 6,
                importe: 0
            },
            listPrecioEsta: [],
            total_pagar: 0,
            rules: {
                cantHour: [{
                    required: true,
                    message: 'Falta la cantidad de horas',
                    trigger: 'change'
                }],
                cndoc: [{
                    validator: validateDoc,
                    trigger: ['blur', 'change']
                }],
                cname: [{
                    required: true,
                    message: 'Ingrese su nombre y apellidos completos',
                    trigger: 'blur'
                },
                {
                    min: 3,
                    max: 50,
                    message: 'Longitud de texto debe ser de 3 a 50 carácteres',
                    trigger: 'blur'
                }
                ],
                cphone: [{
                    required: true,
                    message: 'Ingrese un número de celular'
                },
                {
                    type: 'number',
                    message: 'Celular debe ser números'
                }
                ],
                cemail: [{
                    required: true,
                    message: 'Ingrese una dirección de correo electrónico',
                    trigger: 'blur'
                },
                {
                    type: 'email',
                    message: 'Ingrese una dirección de correo electrónico correcta',
                    trigger: ['blur', 'change']
                }
                ],
                fndoc: [{
                    validator: validateComp,
                    trigger: ['blur', 'change']
                }],
                fname: [{
                    required: true,
                    message: 'Ingrese la información solicitada ',
                    trigger: 'blur'
                },],
                fphone: [{
                    required: true,
                    message: 'Ingrese un número de celular',
                    trigger: ['change', 'blur']
                },
                {
                    type: 'number',
                    message: 'Sólo números',
                    trigger: ['change', 'blur']
                }
                ],
                femail: [{
                    required: true,
                    message: 'Ingrese una dirección de correo electrónico',
                    trigger: 'blur'
                },
                {
                    type: 'email',
                    message: 'Ingrese una dirección de correo electrónico correcta',
                    trigger: ['blur', 'change']
                }
                ],
            },
            calendarHeader: {
                left: 'prev next today',
                center: 'title',
                right: ''
            },
            slotLabelFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour24: true
            }
        }
    },
    async mounted() {
        console.log('mounted ejecutado')
        console.log(this.$refs.fullCalendar)


        /*await services.getPopup({
            service: 2
        }).then((res) => {

            this.popup = res.data
            if (res.data.popup) {
                this.popup = res.data
                this.dialogPopUp = true
            }
        }).catch((err) => {
            alert('Lo sentimos, no se pudo cargar los popups')
        }).finally(() => {})
        */
    },
    methods: {
        showError(message) {
            this.$alert(message, 'Aviso', {
                confirmButtonText: 'Entendido',
                type: 'warning',
                center: true,
            });
        },
        changeTipoDoc() {
            this.maxlength = (this.form.cdoc == '01') ? 8 : 11;
            this.form.cndoc = '';
        },
        handleChange(value) {
            this.form.totalEntradas = 0;
            this.detailEntradas = [];
            for (let index = 0; index < this.entradas.parent_id.length; index++) {
                let element = this.entradas.parent_id[index];

                if (element > 0) {
                    this.form.totalEntradas += this.listPreciosEntradas[index].precioUnitario * element;

                    let entr = {
                        item: (index + 1),
                        cantidad: element,
                        precioUnitario: this.listPreciosEntradas[index].precioUnitario,
                        precioTotal: this.listPreciosEntradas[index].precioUnitario * element,
                        codigoProducto: this.listPreciosEntradas[index].codigo,
                        codigoProductoGrupo: "T",
                        fechaInicio: moment(this.selectDateHour).add((index), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        fechaFin: moment(this.selectDateHour).add((index + 1), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        description: 'Entradas',
                        descriptionProduct: this.listPreciosEntradas[index].descripcion,
                    };
                    this.detailEntradas.push(entr);
                }
            }
            this.total_pagar = this.form.total + this.estacionamiento.importe + this.form.totalEntradas
            //alert( this.form.totalEntradas)
        },
        handleChangeEst(value) {
            this.estacionamiento.precio = this.listPrecioEsta[0].pUnitario
            this.estacionamiento.importe = this.estacionamiento.carros * this.estacionamiento.precio

            this.total_pagar = this.form.total + this.estacionamiento.importe + this.form.totalEntradas
        },
        getListPreciosEsta() {
            this.estacionamiento.carros = 0
            this.estacionamiento.precio = 0
            this.estacionamiento.importe = 0
            this.total_pagar = this.form.total
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                //this.fullscreenLoading = true;
                axiosInstance.post(`${process.env.API4}/v1/cc/result4`, {
                    ue: "001066",
                    sede: this.selectSede,
                    areaId: this.selectSede,
                    categoriaId: "004"
                }).then(response => {
                    this.listPrecioEsta = response.data
                    console.log(response.data);
                    //this.fullscreenLoading = false;
                    //this.listSedes = response.data;
                });
            } catch (error) {
                //this.fullscreenLoading = false;
                this.showError(error);
            }

        },
        toggleWeekends() {
            this.calendarWeekends = !this.calendarWeekends;
        },
        gotoPast() {
            let calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.gotoDate("2000-01-01");
        },
        getListSedes() {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.fullscreenLoading = true;
                axiosInstance.post(`${process.env.API4}/v1/as/busquedaxareaxcancha`).then(response => {
                    this.fullscreenLoading = false;
                    this.listSedes = response.data;
                });
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        getMoreInfo() {
            try {
                if (this.selectSede != null) {
                    this.fullscreenLoading = true;

                    this.getDetailSeat = this.listSedes.filter(data => data.codigoArea == this.selectSede);
                    this.seat = this.getDetailSeat[0];

                    this.listSedes.forEach(element => {
                        const regex = / /gi;
                        if (element.codigoArea == this.selectSede) {
                            //this.slug = element.areaDescripcion.toLowerCase().replace(/\s*$/,"").replace(regex, "-");
                            this.slug = this.selectSede;
                            this.inicioCalendar = element.fechaIncio;
                            this.finCalendar = element.fechaFin + 1;
                            this.finCalendar2 = element.fechaFin + 1;
                        }
                    });
                    this.emptyCalendar();
                    this.calendarEvents = [];
                    this.blockCalendar = false;
                    this.selectCancha = null;
                    this.fullscreenLoading = false;
                    this.getLisTipoCanchas();
                } else {
                    this.$message.error(`Debe seleccionar una sede para continuar.`);
                }
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },

        async isBloqued(selectSede, selectCancha, selectDeporte, selectLosa, selectDateHour, cantidadHoras) {
            try {
                this.fullscreenLoading = true;
                let losita = []
                losita = this.listLosas.filter(data => data.value == selectLosa);
                //console.info(losita);

                // Primera llamada
                const resp1 = await axios.post(`${process.env.API1}/api/canchas/bloqueos`, {
                    periodo: parseInt(moment().format('Y')),
                    idseat: selectSede,
                    idcancha: selectCancha,
                    iddeporte: selectDeporte,
                    idlosa: losita[0].detalle2,
                    fechaInicio: moment(selectDateHour).add((0), 'hours').format('YYYY-MM-DD HH:mm:ss'),
                    fechaFin: moment(selectDateHour).add((cantidadHoras), 'hours').format('YYYY-MM-DD HH:mm:ss')
                });

                this.fullscreenLoading = false;

                if (resp1.data.status === false) {
                    this.showError(resp1.data.message);
                    return false;
                }

                return true;
            } catch (error) {
                this.fullscreenLoading = false;
                console.error(error);
                this.showError("Ocurrió un error al validar el bloqueo. Intente nuevamente.");
                return false;
            }
        },
        async handleDateClick(arg) {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });

            try {
                if (this.selectLosa == null) {
                    this.showError('Estimado usuario, tiene que seleccionar un tipo de losa');
                    return false;
                }

                this.selectDateHour = arg.dateStr;
                this.form.startDate = moment(arg.dateStr).format("dddd DD [de] MMMM");
                this.form.startHour = moment(arg.dateStr).format("hh[:]mm a");

                //Dias festivos
                let isferiado = moment(arg.dateStr).format("YYYY-MM-DD");
                if (isferiado == '2025-12-24' || isferiado == '2025-12-31') {
                    this.showError("Lo sentimos en esta fecha festiva no atenderemos por lo tanto no se podrá agendar tu reserva. Gracias por tu atención");
                    return false;
                }

                //Se Desbloquea por orden de gerencia
                /*
                if(this.selectSede == '00031' && this.selectCancha == 2 && this.selectDeporte == 4 && this.selectLosa == 'GRASS SINTÉTICO 01'){
                this.showError("Lo sentimos este tipo de losa no se encuentra disponible por el momento");
                return false;
                }
                */

                /*
                if(isferiado>="2024-01-01"){
                  this.showError("Lo sentimos, las reservas a partir de esta fecha no estan disponibles");
                            return false;
                }*/


                //visita dina boluarte
                if (this.selectSede == '00030' && isferiado == '2023-10-25') {
                    this.showError('Lo sentimos, No se puede reservar en esta fecha por estar en mantenimiento. gracias por su atención');
                    return false;
                }


                let currentDay = Date.parse(moment().format("YYYY-MM-DD"));
                let currentHour = parseInt(moment().format('H'));

                let selectedDay = Date.parse(moment(arg.dateStr).format("YYYY-MM-DD"));
                let selectedHour = parseInt(moment(this.selectDateHour).format('H'));

                //Fecha y hora no pueden ser menor
                if (selectedDay < currentDay) {
                    this.showError('La fecha seleccionada no puede ser menor');
                    return false;
                }
                if (selectedDay == currentDay) {
                    if (selectedHour <= currentHour) {
                        this.showError('La hora seleccionada no puede ser menor');
                        return false;
                    }
                }

                //correo asistenteamancaes@serpar.gob.pe 30/12/2025 15:11
                /*if(this.selectSede == '00049' && this.selectCancha == 4) {
                    this.showError('Lo sentimos, Este tipo de cancha se encuentra temporalmente fuera de servicio, gracias por su comprensión.');
                    return false;
                }
                */

                //Se bloquea según correo 27/01/2025 16:18
                if (this.selectSede == '00032' && this.selectCancha == 3 && (this.selectDeporte == 9 || this.selectDeporte == 6) && selectedHour > 17) {
                    this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                    return false;
                }


                //losa y horarios no disponible en duracel
                /*if (this.selectSede == '00050' && this.selectCancha == 3 && selectedHour > 17) {
                    this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                    return false;
                }
                */

                //bloqueo por elecciones
                /*if(
                  this.selectSede == '00037' ||
                  this.selectSede == '00019' ||
                  this.selectSede == '00027' ||
                  this.selectSede == '00050' ||
                  this.selectSede == '00025' ||
                  this.selectSede == '00024' ||
                  this.selectSede == '00018')
                {
                    if(isferiado == '2022-09-30' ||
                      isferiado == '2022-10-01' ||
                      isferiado == '2022-10-02' ||
                      isferiado == '2022-10-03'){
                        this.showError('Lo sentimos en esta fecha de Elecciones no atenderemos por lo tanto no se podrá agendar tu reserva. Gracias por tu atención');
                        return false;
                    }
                }*/

                if (this.selectSede == '00019') {
                    if (this.selectLosa == 'LOSA  MULTIUSO 1') {
                        this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                        return false;
                    }
                    let losa2 = this.selectLosa.replace(/\s+/g, '')
                    if (losa2 == "LOSAMULTIUSO2") {
                        console.log(losa2)
                        this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                        return false;
                    }
                }

                if (this.selectSede == '00025') {
                    if (isferiado == '2024-08-18') {
                        this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                        return false;
                    }


                    if (this.selectCancha == 3 && this.selectDeporte == 6 && this.selectLosa == 'LOSA 04') {
                        this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                        return false;
                    }
                    if (this.selectCancha == 1 && this.selectDeporte == 5 && this.selectLosa == 'CAMPO NATURAL 01') {
                        console.log(losa2)
                        this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                        return false;
                    }
                    if (this.selectCancha == 1 && this.selectDeporte == 5 && this.selectLosa == 'CAMPO NATURAL 03') {
                        console.log(losa2)
                        this.showError('Lo sentimos, no se puede reservar en este horario por estar en mantenimiento, gracias por su comprensión.');
                        return false;
                    }
                }

                //Limitar a 1 mes
                let onMonth = Date.parse(moment().add(1, 'months').format("YYYY-MM-DD"));
                //let selectedDay = moment(arg.dateStr).format("YYYY-MM-DD");

                if (selectedDay > onMonth) {
                    this.showError('Lo sentimos, las reservas estan limitadas a 1 mes. Gracias por su atención.');
                    return false;
                }

                //console.log(selectedHour)

                if (this.listarPrecioLosa.length == 0) {
                    this.showError('No se ha cargado la lista de precios para poder validar la disponibilidad');
                    return false;
                }

                const isDisponible = await this.isBloqued(this.selectSede, this.selectCancha, this.selectDeporte, this.selectLosa, this.selectDateHour, 1);
                if (!isDisponible) {
                    return; // corto el flujo
                }

                //validar si tiene bloqueos programador en mysql
                /*this.fullscreenLoading = true;
                let losita= []
                losita = this.listLosas.filter(data => data.value == this.selectLosa);
                console.info(losita);

                // Primera llamada
                const resp1 = await axios.post(`${process.env.API1}/api/canchas/bloqueos`, {
                    periodo: parseInt(moment().format('Y')),
                    idseat: this.selectSede,
                    idcancha: this.selectCancha,
                    iddeporte: this.selectDeporte,
                    idlosa: losita[0].detalle2,
                    fechaInicio: moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD HH:mm:ss'),
                    fechaFin: moment(this.selectDateHour).add((1), 'hours').format('YYYY-MM-DD HH:mm:ss')
                });

                this.fullscreenLoading = false;
                */
                /*
                if(resp1.data.status === false) {
                    this.showError(resp1.data.message);
                    return false;
                }
                */

                this.fullscreenLoading = true;
                let tmpvalidar = [];
                axiosInstance.post(`${process.env.API4}/v1/losa/validarLosa`, {
                    periodo: parseInt(moment().format('Y')),
                    sede: this.selectSede,
                    codigoProductoGrupo: this.listarPrecioLosa[0]['codigo'],
                    fechaInicio: moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                    fechaFin: moment(this.selectDateHour).add((1), 'hours').format('YYYY-MM-DD[T]HH:mm:ss')
                }).then(response => {
                    this.fullscreenLoading = true;
                    tmpvalidar = response.data;
                });

                this.fullscreenLoading = false;
                if (tmpvalidar.length > 0) {
                    this.showError('Horario seleccionado no se encuentra disponible');
                    return false;
                }

                this.calculateEndHourPrice();

                this.dialogFormVisible = true;
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        onDatesRender(info) {
            const start = moment(info.view.currentStart).format('DD/MM/YYYY');
            const end = moment(info.view.currentEnd).format('DD/MM/YYYY');
            const key = start + end

            if (this.lastRange === key) return
            this.lastRange = key
            this.loadEvents(start, end)
        },


        loadEvents(start, end) {
            this.fullscreenLoading = true;
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });

            this.calendarEvents = [];
            axiosInstance.post(`${process.env.API4}/v1/losa/losaReservaCancha`, {
                codigoArea: this.seat.codigoArea,
                codigoCancha: this.selectCancha,
                codigoDeporte: this.selectDeporte,
                descripcionCancha: this.selectLosa,
                fechaInicio: start,
                fechaFin: end
            })
                .then(response => {
                    const eventos = []

                    this.listarPrecioLosa = response.data.listarPrecioLosa;
                    for (let i in this.listarPrecioLosa) {
                        if (this.listarPrecioLosa[i].dias == "L-V")
                            this.$set(this.listarPrecioLosa[i], 'days', 'L,M,J,V');
                        else
                            this.$set(this.listarPrecioLosa[i], 'days', 'S,D,F');
                    }

                    if (response.data.listarRegistroLosa) {

                        response.data.listarRegistroLosa.forEach(element => {
                            let className = this.getClassByTipo(element.tipoSistema)
                            this.calendarEvents.push({
                                title: 'Alquilado, Tipo Sistema: ' + element.tipoSistema,
                                start: element.anioInicio + '-' + element.mesInicio + '-' + element.diaInicio + 'T' + element.horaInicio,
                                description: 'Alquilado',
                                end: element.anioInicio + '-' + element.mesInicio + '-' + element.diaInicio + 'T' + element.horaFin,
                                className: "fc-event-danger fc-event-solid-warning " + className,
                            });

                        })
                    }
                    this.fullscreenLoading = false
                })
                .catch(err => {

                    this.fullscreenLoading = false
                })

            /*
            axios.post('/api', { start, end }).then(res => {
                this.calendarEvents = res.data
            })
            */
        },
        async calculateEndHourPrice() {

            const isDisponible = await this.isBloqued(this.selectSede, this.selectCancha, this.selectDeporte, this.selectLosa, this.selectDateHour, this.form.cantHour);
            if (!isDisponible) {
                this.dialogFormVisible = false;
                return; // corto el flujo
            }


            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.form.endHour = moment(this.selectDateHour).add(this.form.cantHour, 'Hours').format("hh[:]mm a");

                if (moment(this.selectDateHour).add(this.form.cantHour, 'Hours').format('HH') > parseInt(this.finCalendar)) {
                    this.$alert('La cantidad de horas seleccionada sobrepasa la hora permitida de reserva', 'Alerta', {
                        confirmButtonText: 'Entendido',
                        type: 'error',
                        center: true,
                        callback: action => {
                            this.form.cantHour = null;
                            this.form.total = 0;
                            this.detailCourt = [];
                        }
                    });
                } else {
                    this.fullscreenLoading = true;
                    this.form.total = 0;
                    this.detailCourt = [];

                    axiosInstance.post(`${process.env.API4}/v1/losa/buscarPrecioLosaHorario`, {
                        codigoArea: this.seat.codigoArea,
                        codigoCancha: this.selectCancha,
                        codigoDeporte: this.selectDeporte,
                        descripcionCancha: this.selectLosa,
                        fechaReserva: moment(this.selectDateHour).format('YYYY-MM-DD'),
                        fechaInicio: moment(this.selectDateHour).format('YYYYMMDD'),
                        fechaFin: moment(this.selectDateHour).format('YYYYMMDD'),
                        horaInicio: moment(this.selectDateHour).format('HH:mm:ss'),
                        horaFin: moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('HH:mm:ss'),
                    }).then(response => {
                        // console.log(response.data);

                        let _chours = 0;
                        let item = 0;
                        let horas = 0;
                        let mImporte = 0;
                        response.data.forEach(element => {
                            item += 1;
                            horas = parseInt(element.horas);
                            mImporte = parseInt(horas) * parseInt(element.precioUnitario);

                            let court = {
                                item: item,
                                cantidad: horas,
                                precioUnitario: element.precioUnitario,
                                precioTotal: mImporte,
                                codigoProducto: element.codigoProducto,
                                codigoProductoGrupo: element.codigo,
                                fechaInicio: moment(this.selectDateHour).add((_chours), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                                fechaFin: moment(this.selectDateHour).add((_chours + horas), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                                description: element.descripcion,
                                descriptionProduct: element.descripcionProducto,
                            };
                            _chours = _chours + horas;
                            this.detailCourt.push(court);
                            this.form.total += mImporte + this.form.totalEntradas;
                            this.total_pagar = this.form.total + this.estacionamiento.importe + this.form.totalEntradas
                            //this.total_pagar = this.form.total + this.estacionamiento.importe
                            //this.form.totalEntradas +
                        });

                        this.fullscreenLoading = false;
                    });
                }
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        closePopup() {
            this.form.cantHour = 1;
        },
        onOpenedModal() {
            this.getListPreciosEsta();
            this.getPrecioEntradas();
        },
        /*calculateEndHour() {
            this.form.endHour = moment(this.selectDateHour).add(this.form.cantHour, 'Hours').calendar();
            let dayName = moment(this.selectDateHour).format('dddd');
            dayName = dayName.toUpperCase().substring(0, 1);

            if(moment(this.selectDateHour).add(this.form.cantHour, 'Hours').format('HH')>parseInt(this.finCalendar)){
                this.$alert('La cantidad de horas seleccionada sobrepasa la hora permitida de reserva', 'Alerta', {
                    confirmButtonText: 'Entendido',
                    type: 'error',
                    center: true,
                    callback: action => {
                        this.form.cantHour = null;
                        this.form.total = 0;
                        this.detailCourt=[];
                    }
                });
            }else{

                this.form.total = 0;
                this.detailCourt=[];
                for (let index = 0; index < this.form.cantHour; index++) {
                    let hStart = moment(this.selectDateHour).add((index), 'hours').format('H');
                    let hEnd   = moment(this.selectDateHour).add((index+1), 'hours').format('H');

                    this.listarPrecioLosa.forEach(element => {
                        if (element.days.indexOf(dayName) >= 0) {
                            if(parseInt(hStart)>=parseInt(element.inicio) && parseInt(hEnd)<=parseInt(element.fin)){
                                let court = {
                                    item: (index+1),
                                    cantidad: 1,
                                    precioUnitario: element.precioUnitario,
                                    precioTotal: element.precioUnitario,
                                    codigoProducto: element.codigoProducto,
                                    codigoProductoGrupo: element.codigo,
                                    fechaInicio: moment(this.selectDateHour).add((index), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                                    fechaFin: moment(this.selectDateHour).add((index+1), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                                    description: element.descripcion,
                                    descriptionProduct: element.descripcionProducto,
                                };
                                this.detailCourt.push(court);
                                this.form.total += element.precioUnitario;
                            }
                        }
                    });
                }
            }
        },*/

        getPrecioEntradas() {
            console.log('Listando entradas')
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.fullscreenLoading = true;
                axiosInstance.post(`${process.env.API4}/v1/losa/listarEntrada`, {
                    codigoArea: this.seat.codigoArea,
                    fechaInicio: moment(this.selectDateHour).format('YYYY-MM-DD[T]HH:mm:ss'),
                }).then(response => {
                    this.fullscreenLoading = false;
                    //if(response.data.length > 0) {this.entradasCanchas = true}
                    this.listPreciosEntradas = response.data;

                });
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },

        //info del parque
        getInfSeat() {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.fullscreenLoading = true;
                var formdata = new FormData();
                formdata.append('tipo', 2);
                formdata.append('search', this.slug);
                axiosInstance.post(`${process.env.API1}/seat/info`, formdata).then(response => {
                    this.fullscreenLoading = false;
                    this.seat = response.data;
                });
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        //obtener lista de canchas
        getLisTipoCanchas() {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.fullscreenLoading = true;
                axiosInstance.post(`${process.env.API4}/v1/losa/buscarTipoLosa`, {
                    codigoArea: this.selectSede
                }).then(response => {
                    this.fullscreenLoading = false;
                    this.listTipos = response.data;
                })
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        //obtener lista de deportes en base a la cancha
        getListDeporte() {
            /*
            if (this.selectSede == '00050') {
                this.showError('Lo sentimos, este tipo de cancha no se encuentra habilitado por el momento. Gracias por su comprensión.');
                return false
            }
            */

            //CORREO DE HUASCAR huas-asist02@serpar.gob.pe 30/12/2025 10:37
            if (this.selectSede == '00020' && this.selectCancha == "3") {

                this.showError('Lo sentimos, este tipode cancha no se encuentra habilitado por el momento. Gracias por su comprensión.');
                this.selectCancha = null
                this.blockCalendar = false;
                this.selectDeporte = null;

                return false

            }

            if ((
                this.selectSede == '00020' ||
                this.selectSede == '00024') && this.selectCancha == "1") {

                this.showError('Lo sentimos, este tipode cancha no se encuentra habilitado por el momento. Gracias por su comprensión.');
                this.selectCancha = null
                this.blockCalendar = false;
                this.selectDeporte = null;

                return false

            }




            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.blockCalendar = false;
                this.selectDeporte = null;
                this.listarPrecioLosa = [];

                if (this.selectCancha != null) {
                    this.fullscreenLoading = true;
                    this.form.seat = this.seat.codigoArea;
                    axiosInstance.post(`${process.env.API4}/v1/losa/buscarDeporte`, {
                        codigoArea: this.seat.codigoArea,
                        codigoCancha: this.selectCancha
                    }).then(response => {
                        this.calendarEvents.length = 0;
                        this.emptyCalendar();

                        this.listDeportes = [];
                        this.listDeportes = response.data;
                        this.fullscreenLoading = false;
                        if (this.listDeportes.length == 0) {
                            this.showError('No se encontró deportes disponibles para el tipo de cancha seleccionada');
                        }
                    })
                }
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        //obtener lista de lozas
        getListLosas() {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.selectLosa = null;
                this.listarPrecioLosa = [];
                if (this.selectDeporte != null) {
                    this.fullscreenLoading = true;
                    axiosInstance.post(`${process.env.API4}/v1/losa/buscarLosa`, {
                        codigoArea: this.seat.codigoArea,
                        codigoCancha: this.selectCancha,
                        codigoDeporte: this.selectDeporte
                    }).then(response => {
                        this.calendarEvents.length = 0;
                        this.emptyCalendar();
                        this.listLosas = [];
                        this.listLosas = response.data;
                        this.fullscreenLoading = false;
                        if (this.listLosas.length == 0) {
                            this.blockCalendar = false;
                            this.showError('No se encontró losas disponibles para el deporte seleccionado.');
                        } else {
                            this.blockCalendar = true;
                        }
                    });
                }
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },

        getNewHourClosed() {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            //conultando si existe nuevo horario de cierre para la losa
            try {
                this.fullscreenLoading = true;
                let detallecg = []

                //obteniendo codigoproducto grupo
                detallecg = this.listLosas.filter(data => data.value == this.selectLosa);
                axiosInstance.post(`${process.env.API4}/v1/losa/grupo/horario`, {
                    ue: "001066",
                    sede: "001",
                    area: this.seat.codigoArea,
                    grupo: detallecg[0].detalle2
                }).then(response => {
                    this.fullscreenLoading = false;
                    let res = response.data
                    //console.log(res[0])
                    if (response.data.length > 0) {
                        //console.log(res[0].horaFin)
                        this.finCalendar = res[0].horaFin;
                    } else {
                        this.finCalendar = this.finCalendar2
                    }
                    const calendarApi = this.$refs.fullCalendar.getApi()
                    const view = calendarApi.view

                    // Inicio de la semana (lunes)
                    const start = new Date(view.currentStart)

                    // Fin exclusivo → restamos 1 día para domingo real
                    const end = new Date(view.currentEnd)
                    end.setDate(end.getDate() - 1)

                    this.loadEvents(moment(start).format('DD/MM/YYYY'), moment(end).format('DD/MM/YYYY'))
                })
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        getClassByTipo(tipo) {
            switch (tipo) {
                case "ART": return "bg-success"
                case "ART-MOBILE": return "bg-primary"
                case "SPV": return "bg-warning"
                case "BD": return "bg-blue"
                default: return "bg-secondary"
            }
        },
        changeTpodocument() {
            this.form.fndoc = '';
            this.maxlength = (this.form.voucher == '03') ? 8 : 11;
            this.placeHolder.voucher = (this.form.voucher == '03') ? 'DNI' : 'RUC';
            this.placeHolder.namebussines = (this.form.voucher == '03') ? 'Nombres' : 'Razon social';
        },

        submitForm(formName) {

            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!this.terms) {
                            this.$message.error('Falta seleccionar los Términos y Condiciones');
                            return false;
                        }

                        if (this.form.totalEntradas <= 0 && this.listPreciosEntradas.length > 0) {
                            return this.$message.error('Falta ingresar la cantidad de entradas');
                            return false
                        }

                        if (this.form.total == 0)
                            return this.$message.error('El precio por alquiler de espacios es 0, por favor seleccione un rango de horas válidas');

                        this.fullscreenLoading = true;

                        axiosInstance.post(`${process.env.API4}/v1/losa/validarLosa`, {
                            "periodo": parseInt(moment().format('Y')),
                            "sede": this.form.seat,
                            "codigoProductoGrupo": this.listarPrecioLosa[0].codigo,
                            "fechaInicio": moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                            "fechaFin": moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('YYYY-MM-DD[T]HH:mm:ss')
                        }).then(response => {
                            this.fullscreenLoading = false;
                            if (response.data.length != 0) {
                                this.showError('El rango de fecha/hora ingresada del ' + moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD HH:mm') + ' al ' + moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('YYYY-MM-DD HH:mm') + ' se encuentra en uso.');
                            } else {
                                this.sendSale();
                            }
                        });

                    } else {
                        return false;
                    }
                });
            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        },
        emptyCalendar() {
            this.calendarEvents.push({
                title: '',
                start: '',
                description: '',
                end: '',
                className: '',
            });
        },
        sendSale() {
            const axiosInstance = axios.create({
                headers: {
                    "Access-Control-Allow-Origin": "*"
                }
            });
            try {
                this.fullscreenLoading = true;
                this.detailEntradas.forEach(element => {
                    let court = {
                        item: (this.detailCourt.length + 1),
                        cantidad: element.cantidad,
                        precioUnitario: element.precioUnitario,
                        precioTotal: element.precioTotal,
                        codigoProducto: element.codigoProducto,
                        codigoProductoGrupo: "",
                        fechaInicio: moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        fechaFin: moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        description: element.description,
                        descriptionProduct: element.descriptionProduct,
                    };
                    this.detailCourt.push(court);
                });

                if (this.estacionamiento.carros > 0) {
                    let court = {
                        item: (this.detailCourt.length + 1),
                        cantidad: this.estacionamiento.carros,
                        precioUnitario: this.estacionamiento.precio,
                        precioTotal: this.estacionamiento.importe,
                        codigoProducto: this.listPrecioEsta[0].productoId,
                        codigoProductoGrupo: this.listarPrecioLosa[0].codigo,
                        fechaInicio: moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        fechaFin: moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        description: this.listPrecioEsta[0].categoriaDescripcion,
                        descriptionProduct: this.listPrecioEsta[0].productoDescripcion,
                    };
                    this.detailCourt.push(court);
                }

                axiosInstance.post(`${process.env.API4}/v1/reserva/registroReserva`, {
                    "canchaParameterA": {
                        "sede": this.form.seat,
                        "codigoArea": this.form.seat,
                        "codigoProducto": null,
                        "codigoProductoGrupo": this.listarPrecioLosa[0].codigo,
                        "tipoComprobante": this.form.voucher,
                        "fechaInicio": moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        "fechaFin": moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('YYYY-MM-DD[T]HH:mm:ss'),
                        "usuarioReserva": this.form.cname,
                        "telefonoReserva": this.form.cphone,
                        "emailReserva": this.form.cemail,
                        "datoComprobante": this.form.cdoc,
                        "dniRucComprobante": this.form.fndoc,
                        "telefonoComprobante": this.form.fphone,
                        "emailComprobante": this.form.femail,
                        "estadoTransaccion": 0,
                        "tipoSistema": "ART"
                    },
                    "canchaParameterB": this.detailCourt
                }).then(response => {
                    if (parseInt(response.data) > 0) {
                        this.form.operation = parseInt(response.data);
                        this.form.startDate = moment(this.selectDateHour).add((0), 'hours').format('YYYY-MM-DD HH:mm:ss')
                        this.form.endDate = moment(this.selectDateHour).add((this.form.cantHour), 'hours').format('YYYY-MM-DD HH:mm:ss')
                        axios.post(`${process.env.API1}/canchas/register`, {
                            "headboard": this.form,
                            "details": this.detailCourt
                        }).then(response => {
                            this.fullscreenLoading = false;
                            if (response.data.status == 'success') {
                                window.location.href = response.data.url
                            } else {
                                this.fullscreenLoading = false;
                                this.showError(response.data.message);
                            }
                        })
                    } else {
                        this.fullscreenLoading = false;
                        this.showError('Ya hay una reserva en curso para las fechas seleccionadas.');
                    }
                });


            } catch (error) {
                this.fullscreenLoading = false;
                this.showError(error);
            }
        }
    },
    created() {
        this.getListSedes();
    },
    errorCaptured(err, vm, info) {
        // console.log("mels");
    }
}
</script>

<style>
.bg-table-price {
    background: #F2F6FC !important;
    font-weight: bold !important;
}

.el-select {
    width: 100%;
}

.mitable {
    border: 1px solid !important;
}

.sky-form .icon_logos2 {
    margin-top: -10px;
    height: 48px;
}

.sky-form .band_logos {
    height: 22px;
    width: 36px;
}

.prices td,
.prices th {
    padding: 0px 0 !important;
}

.alert p {
    line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/canchas/Index.vue